import React from 'react';
import { NOTIFICATION_SETTING_NAMES } from '../notifications.config';
import { createAvoidNotificationsDuplicationModalOptions } from 'modals/modal-options-factory';

const modalContentOptionsCurrentlyTurnedOn = {
  similar: ({ notificationsConfig, similarNotificationTurnedOnKey }) => (
    <>
      <span style={{ fontWeight: 'bold' }}>
        {notificationsConfig[similarNotificationTurnedOnKey].name}
      </span>{' '}
      notification is currently
      <br /> turned on for your team.
    </>
  ),
  overload: ({ otherNotificationTypeKey }) => (
    <>
      <span style={{ fontWeight: 'bold' }}>
        {NOTIFICATION_SETTING_NAMES[otherNotificationTypeKey]}
      </span>{' '}
      notification is turned on for this goal.
    </>
  )
};

const modalContentOptionsUserWantsToTurnedOn = {
  similar: ({ name }) => (
    <>
      Enabling <span style={{ fontWeight: 'bold' }}>{name}</span> may result in
      <br /> notification duplication.
    </>
  ),
  overload: ({ currNotificationTypeKey }) => (
    <>
      Turn on{' '}
      <span style={{ fontWeight: 'bold' }}>
        {NOTIFICATION_SETTING_NAMES[currNotificationTypeKey]}{' '}
      </span>{' '}
      notification as well?{' '}
    </>
  )
};

export const notificationCurrentlyTurnedOn = props =>
  modalContentOptionsCurrentlyTurnedOn[props.modalContent]?.(props) || <></>;

export const notificationUserWantsToTurnedOn = props =>
  modalContentOptionsUserWantsToTurnedOn[props.modalContent]?.(props) || <></>;

export const openNotificationDuplicationModal = props => {
  const {
    toggleModal,
    toggleNotificationsForTeam,
    currEnabled,
    currNotificationTypeKey,
    id,
    notificationKey,
    name,
    modalContent
  } = props;
  toggleModal(
    createAvoidNotificationsDuplicationModalOptions({
      NotificationCurrentlyTurnedOn: () => notificationCurrentlyTurnedOn(props),
      NotificationUserWantsToTurnedOn: () =>
        notificationUserWantsToTurnedOn(props),

      onConfirm: async () => {
        try {
          await toggleNotificationsForTeam(
            !currEnabled,
            currNotificationTypeKey,
            id,
            notificationKey,
            name
          );

          toggleModal();
        } catch (e) {}
      },
      onCancel: () => toggleModal(),
      title:
        modalContent === 'similar'
          ? 'Potential notification duplication'
          : 'Potential notification overload'
    })
  );
};

export const shouldOpenNotificationDuplicationModalForSimilar = ({
  currEnabled,
  similarNotifications,
  similarNotificationTurnedOnKey,
  otherNotificationEnabled
}) => {
  return !!(
    similarNotifications.length &&
    !currEnabled &&
    similarNotificationTurnedOnKey &&
    !otherNotificationEnabled
  );
};

export const shouldOpenNotificationDuplicationModalForOverLoad = ({
  otherNotificationEnabled,
  currEnabled
}) => otherNotificationEnabled && !currEnabled;
